import { render, staticRenderFns } from "./membership-calculation-categories.vue?vue&type=template&id=30dbab1c&scoped=true"
import script from "./membership-calculation-categories.vue?vue&type=script&lang=js"
export * from "./membership-calculation-categories.vue?vue&type=script&lang=js"
import style0 from "./membership-calculation-categories.vue?vue&type=style&index=0&id=30dbab1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dbab1c",
  null
  
)

export default component.exports